<template>
  <div class="input-style" :class="{'input-error': error}">
    <input
      type="text"
      :placeholder="placeHolder"
      :id="idName + (index == 0 || index ? index : '')"
      class="form-control"
      v-model="value"
      @input="onInput"
      @keyup="onKeyup"
      @focus="typeInputOptions(index)"
      @blur="outFocus"
      @keyup.enter="checkNewOption"
      ref="inputStyle"
      :index="index"
      :maxlength="limit"
      autocomplete="off"
    >
    <span class="value-validate-length" v-if="isFocus">{{ lengthValue }}</span>
    <div class="input-error-style" v-if="error && isFocus && type != 'input-field'">
      <div class="arrow_box">
        You have reached the maximum length!
      </div>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce'
import { setTimeout } from 'timers'
import { mapState } from 'vuex'
import EventBus from '@/eventBus'

export default {
  props: {
    val: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 150,
    },
    id: {
      type: Number,
      default: null,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    index: {
      type: [Number, String],
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    idName: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      key: null,
      value: this.val,
      lastValue: null,
      isFocus: false,
      error: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isSlideOptionOldTitle() {
      return this.index && this.slideActive.SlideOptions[this.index] &&
      this.value == this.slideActive.SlideOptions[this.index].title
    },
    lengthValue() {
      let currentValueLength = 0
      if (this.value) {
        currentValueLength = this.value.length
      }
      return this.limit - currentValueLength
    },
  },
  watch: {
    val() {
      this.value = this.val
    },
  },
  mounted() {
    const self = this
    if (this.inputId) {
      EventBus.$on(`update-right-column-for-${this.inputId}`, (newValue) => {
        this.value = newValue
      })
    }

    if (this.$store.state.slideActive.type == 'pickAnswer' && this.$store.state.slideActive.slideType == 'typeAnswer') {
      this.$refs.inputStyle.onkeydown = function (evt) {
        evt = evt || window.event
        if (evt.keyCode == 9 && self.$refs.inputStyle.getAttribute('index') == self.$store.state.slideActive.otherCorrectQuiz.length - 1) {
          self.checkNewOption()
        }
      }
      return
    }

    this.$refs.inputStyle.onkeydown = function (evt) {
      evt = evt || window.event
      if (evt.keyCode == 9 && self.$refs.inputStyle.getAttribute('index') == self.$store.state.slideActive.SlideOptions.length - 1) {
        self.checkNewOption()
      }
    }
  },

  destroyed() {
    EventBus.$off(`update-right-column-for-${this.inputId}`)
  },

  methods: {
    onInput: debounce(function debounceOnInput() {
      if (this.value === null || this.value === undefined) {
        this.value = ''
      }

      if (this.value.length <= this.limit) {
        this.error = false
        if (this.lastValue !== this.value) {
          this.$emit('interface', {
            value: this.value,
            id: this.id,
            index: this.index,
            idName: this.idName,
          })
          this.lastValue = this.value
        }
      } else {
        this.error = true
      }
    }, 650),

    onKeyup() {
      if (this.value === null || this.value === undefined) {
        this.value = ''
      }
      if (this.value.length > this.limit) {
        this.value = this.value.substr(0, this.limit)
      }
    },

    checkNewOption() {
      const optionsLength = this.slideActive.SlideOptions.length
      if (this.type != 'input-option') {
        if (this.slideActive.type == 'pickAnswer' && this.slideActive.slideType == 'typeAnswer') {
          if (this.slideActive.otherCorrectQuiz.length < 8) {
            const index = this.slideActive.otherCorrectQuiz.length + 1
            this.slideActive.otherCorrectQuiz.push({
              index,
              id: Math.random().toString(36).substring(7),
            })
            setTimeout(() => {
              if (!window.document.getElementById(this.idName + (index - 1))) return
              window.document.getElementById(this.idName + (index - 1)).focus()
            }, 200)
          }
        }
        return
      }

      if (optionsLength > 29) {
        return
      }
      if (this.slideActive.type == 'bulletPoints' && optionsLength > 14) {
        return
      }

      if (this.$refs.inputStyle.getAttribute('index') == optionsLength - 1) {
        this.$store.state.slideActive.SlideOptions.push({
          index: optionsLength + 1,
        })
        setTimeout(() => {
          this.$emit('add-option')
        }, 450)
        setTimeout(() => {
          if (!window.document.getElementById(this.idName + (this.index + 1))) return
          window.document.getElementById(this.idName + (this.index + 1)).focus()
        }, 200)
      }
    },

    outFocus: debounce(function debounceOutFocus() {
      this.isFocus = false
      if (this.type != 'input-field') {
        if (this.isSlideOptionOldTitle) {
          return
        }
      } else if (this.value.trim() == '') {
        this.error = true
      }

      if (this.lastValue !== this.value) {
        this.$emit('interface', {
          value: this.value,
          id: this.id,
          index: this.index,
          idName: this.idName,
        })
        this.lastValue = this.value
      }
    }, 250),
    typeInputOptions() {
      this.isFocus = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';

.input-style {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;

  .value-validate-length {
    position: absolute;
    right: 10px;
    top: 14px;
    color: $nobel-color;
    font-size: 13px;
  }
  input {
    padding-right: 40px;
  }

  .input-error-style {
    position: absolute;
    top: -100%;
    margin-top: -5px;
    font-size: 14px;
  }

  .arrow_box {
    position: relative;
    background: #000;
    padding: 10px;
    color: #fff;
    border-radius: 5px;
  }
  .arrow_box:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(0, 0, 0, 0);
    border-top-color: #000;
    border-width: 8px;
    margin-left: -8px;
  }
}
</style>
